const strip = (value) => (value ? value.replace(/[^\w]/gi, '') : '')

const buildPath = (category, vehicle) => {
  let querystring =
    (typeof window !== 'undefined' && window.location.search) || ''

  if (!vehicle) {
    return `/${category}s/used/${querystring}`
  } else if (!vehicle.registration) {
    return `/${category}s/used?brand=${vehicle.brand}${
      vehicle.model && `&model=${vehicle.model}`
    }`.toLowerCase()
  } else {
    return `/${category}s/used/${vehicle.brand}${vehicle.model && '/'}${strip(
      vehicle.model
    )}${vehicle.registration && '/'}${vehicle.registration || ''}`.toLowerCase()
  }
}

module.exports = buildPath
